import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Chatbotmessages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.chatbotmessages_Id,
          sortable: true,
          cell: (row) => <span>{row.chatbotmessages_Id}</span>,
        },
        { name: "Conversation Id", selector: (row, i) => row.conversation_id, sortable: true, cell: (row) => <span>{row.conversation_id}</span>, }, { name: "Message Type", selector: (row, i) => row.message_type, sortable: true, cell: (row) => <span>{row.message_type}</span>, }, { name: "Message Content", selector: (row, i) => row.message_content, sortable: true, cell: (row) => <span>{row.message_content}</span>, }, { name: "Message Intent", selector: (row, i) => row.message_intent, sortable: true, cell: (row) => <span>{row.message_intent}</span>, }, { name: "Confidence Score", selector: (row, i) => row.confidence_score, sortable: true, cell: (row) => <span>{row.confidence_score}</span>, }, { name: "Response Time Ms", selector: (row, i) => row.response_time_ms, sortable: true, cell: (row) => <span>{row.response_time_ms}</span>, }, { name: "Contains Sensitive Data", selector: (row, i) => row.contains_sensitive_data, sortable: true, cell: (row) => <span>{row.contains_sensitive_data}</span>, }, { name: "Processed By Claude", selector: (row, i) => row.processed_by_claude, sortable: true, cell: (row) => <span>{row.processed_by_claude}</span>, }, { name: "Suggested Actions", selector: (row, i) => row.suggested_actions, sortable: true, cell: (row) => <span>{row.suggested_actions}</span>, }, { name: "Message Timestamp", selector: (row, i) => row.message_timestamp, sortable: true, cell: (row) => <span>{row.message_timestamp}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ChatbotmessageseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      chatbotmessages_Id: "",
      conversations: [], conversation_id: '', chatbotmessagetypemaster: [], message_type: '', message_content: '', message_intent: '', confidence_score: '', response_time_ms: '', contains_sensitive_data: '', processed_by_claude: '', suggested_actions: '', message_timestamp: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'conversation_id', inputType: 'Select', displayName: 'Conversation Id', validationOptions: { isRequired: false } },
      { fieldName: 'message_type', inputType: 'Select', displayName: 'Message Type', validationOptions: { isRequired: false } },
      { fieldName: 'message_content', inputType: 'Text', displayName: 'Message Content', validationOptions: { isRequired: false } },
      { fieldName: 'message_intent', inputType: 'Text', displayName: 'Message Intent', validationOptions: { isRequired: false } },
      { fieldName: 'confidence_score', inputType: 'Text', displayName: 'Confidence Score', validationOptions: { isRequired: false } },
      { fieldName: 'response_time_ms', inputType: 'Number', displayName: 'Response Time Ms', validationOptions: { isRequired: false } },
      { fieldName: 'contains_sensitive_data', inputType: 'Number', displayName: 'Contains Sensitive Data', validationOptions: { isRequired: false } },
      { fieldName: 'processed_by_claude', inputType: 'Number', displayName: 'Processed By Claude', validationOptions: { isRequired: false } },
      { fieldName: 'suggested_actions', inputType: 'Text', displayName: 'Suggested Actions', validationOptions: { isRequired: false } },
      { fieldName: 'message_timestamp', inputType: 'Date', displayName: 'Message Timestamp', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      conversations: [], conversation_id: '', chatbotmessagetypemaster: [], message_type: '', message_content: '', message_intent: '', confidence_score: '', response_time_ms: '', contains_sensitive_data: '', processed_by_claude: '', suggested_actions: '', message_timestamp: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      conversations: [], conversation_id: '', chatbotmessagetypemaster: [], message_type: '', message_content: '', message_intent: '', confidence_score: '', response_time_ms: '', contains_sensitive_data: '', processed_by_claude: '', suggested_actions: '', message_timestamp: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  ChatbotmessageseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      chatbotmessages_Id: row.chatbotmessages_Id,
      conversations: [], conversation_id: row.conversation_id, chatbotmessagetypemaster: [], message_type: row.message_type, message_content: row.message_content, message_intent: row.message_intent, confidence_score: row.confidence_score, response_time_ms: row.response_time_ms, contains_sensitive_data: row.contains_sensitive_data, processed_by_claude: row.processed_by_claude, suggested_actions: row.suggested_actions, message_timestamp: row.message_timestamp,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  ChatbotmessagesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Chatbotmessages/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  ChatbotmessagessubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('conversation_id', this.state.conversation_id);
    formData.append('message_type', this.state.message_type);
    formData.append('message_content', this.state.message_content);
    formData.append('message_intent', this.state.message_intent);
    formData.append('confidence_score', this.state.confidence_score);
    formData.append('response_time_ms', this.state.response_time_ms);
    formData.append('contains_sensitive_data', this.state.contains_sensitive_data);
    formData.append('processed_by_claude', this.state.processed_by_claude);
    formData.append('suggested_actions', this.state.suggested_actions);
    formData.append('message_timestamp', this.state.message_timestamp);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Chatbotmessages/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotmessagesfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ conversations: [], conversation_id: '', chatbotmessagetypemaster: [], message_type: '', message_content: '', message_intent: '', confidence_score: '', response_time_ms: '', contains_sensitive_data: '', processed_by_claude: '', suggested_actions: '', message_timestamp: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  ChatbotmessagesupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("chatbotmessages_Id", this.state.chatbotmessages_Id);
    formData.append('conversation_id', this.state.conversation_id);
    formData.append('message_type', this.state.message_type);
    formData.append('message_content', this.state.message_content);
    formData.append('message_intent', this.state.message_intent);
    formData.append('confidence_score', this.state.confidence_score);
    formData.append('response_time_ms', this.state.response_time_ms);
    formData.append('contains_sensitive_data', this.state.contains_sensitive_data);
    formData.append('processed_by_claude', this.state.processed_by_claude);
    formData.append('suggested_actions', this.state.suggested_actions);
    formData.append('message_timestamp', this.state.message_timestamp);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Chatbotmessages/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotmessagesfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.ChatbotmessagesfetchHandler();
    this.conversationsfetchHandler();
    this.chatbotmessagetypemasterfetchHandler();

    //***componentDidMount
  }

  handleconversation_idChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ conversation_id: fieldValue });
  }; conversationsfetchHandler = () => {
    fetch(configData.api_url + "C_Conversations/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ conversations: data.list });
        }
      });
  }; handlemessage_typeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ message_type: fieldValue });
  }; chatbotmessagetypemasterfetchHandler = () => {
    fetch(configData.api_url + "C_Chatbotmessagetypemaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ chatbotmessagetypemaster: data.list });
        }
      });
  }; handlemessage_contentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ message_content: fieldValue });
  }; handlemessage_intentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ message_intent: fieldValue });
  }; handleconfidence_scoreChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ confidence_score: fieldValue });
  }; handleresponse_time_msChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ response_time_ms: fieldValue });
  }; handlecontains_sensitive_dataChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ contains_sensitive_data: fieldValue });
  }; handleprocessed_by_claudeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ processed_by_claude: fieldValue });
  }; handlesuggested_actionsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ suggested_actions: fieldValue });
  }; handlemessage_timestampChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ message_timestamp: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this chatbotmessages?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('chatbotmessages_Id', row.chatbotmessages_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Chatbotmessages/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotmessagesfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Chatbot Messages</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Chatbotmessages</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Conversation Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handleconversation_idChange}>
                                        <option defaultValue> Select Conversation Id </option>
                                        {this.state.conversations.map((api, index, idx) => (
                                          <option key={index} value={api.conversations_Id}> {api.conversations_Id} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conversation_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Message Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handlemessage_typeChange}>
                                        <option defaultValue> Select Message Type </option>
                                        {this.state.chatbotmessagetypemaster.map((api, index, idx) => (
                                          <option key={index} value={api.user}> {api.user} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.message_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Message Content</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlemessage_contentChange} className="form-control" name="message_content" value={this.state.message_content} required="required" placeholder="Enter Message Content" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.message_content} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Message Intent</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlemessage_intentChange} className="form-control" name="message_intent" value={this.state.message_intent} required="required" placeholder="Enter Message Intent" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.message_intent} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Confidence Score</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleconfidence_scoreChange} className="form-control" name="confidence_score" value={this.state.confidence_score} required="required" placeholder="Enter Confidence Score" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.confidence_score} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Response Time Ms</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleresponse_time_msChange} className="form-control" name="response_time_ms" value={this.state.response_time_ms} required="required" placeholder="Enter Response Time Ms" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.response_time_ms} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Contains Sensitive Data</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecontains_sensitive_dataChange} className="form-control" name="contains_sensitive_data" value={this.state.contains_sensitive_data} required="required" placeholder="Enter Contains Sensitive Data" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.contains_sensitive_data} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Processed By Claude</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleprocessed_by_claudeChange} className="form-control" name="processed_by_claude" value={this.state.processed_by_claude} required="required" placeholder="Enter Processed By Claude" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.processed_by_claude} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Suggested Actions</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlesuggested_actionsChange} className="form-control" name="suggested_actions" value={this.state.suggested_actions} required="required" placeholder="Enter Suggested Actions" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.suggested_actions} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Message Timestamp</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlemessage_timestampChange} className="form-control" name="message_timestamp" value={this.state.message_timestamp} required="required" placeholder="Enter Message Timestamp" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.message_timestamp} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.ChatbotmessagessubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Chatbotmessages</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Conversation Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handleconversation_idChange}>
                                          <option defaultValue> Select Conversation Id </option>
                                          {this.state.conversations.map((api, index, idx) => (
                                            <option key={index} value={api.conversations_Id}> {api.conversations_Id} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conversation_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Message Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handlemessage_typeChange}>
                                          <option defaultValue> Select Message Type </option>
                                          {this.state.chatbotmessagetypemaster.map((api, index, idx) => (
                                            <option key={index} value={api.user}> {api.user} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.message_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Message Content</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlemessage_contentChange} className="form-control" name="message_content" value={this.state.message_content} required="required" placeholder="Enter Message Content" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.message_content} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Message Intent</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlemessage_intentChange} className="form-control" name="message_intent" value={this.state.message_intent} required="required" placeholder="Enter Message Intent" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.message_intent} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Confidence Score</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleconfidence_scoreChange} className="form-control" name="confidence_score" value={this.state.confidence_score} required="required" placeholder="Enter Confidence Score" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.confidence_score} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Response Time Ms</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleresponse_time_msChange} className="form-control" name="response_time_ms" value={this.state.response_time_ms} required="required" placeholder="Enter Response Time Ms" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.response_time_ms} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Contains Sensitive Data</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecontains_sensitive_dataChange} className="form-control" name="contains_sensitive_data" value={this.state.contains_sensitive_data} required="required" placeholder="Enter Contains Sensitive Data" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.contains_sensitive_data} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Processed By Claude</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleprocessed_by_claudeChange} className="form-control" name="processed_by_claude" value={this.state.processed_by_claude} required="required" placeholder="Enter Processed By Claude" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.processed_by_claude} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Suggested Actions</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlesuggested_actionsChange} className="form-control" name="suggested_actions" value={this.state.suggested_actions} required="required" placeholder="Enter Suggested Actions" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.suggested_actions} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Message Timestamp</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlemessage_timestampChange} className="form-control" name="message_timestamp" value={this.state.message_timestamp} required="required" placeholder="Enter Message Timestamp" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.message_timestamp} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.ChatbotmessagesupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}